// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"Button_buttonWrapper__9Vvy_","load":"Button_load___Y_wM"};